import { Col } from "react-bootstrap";
import HobbiesPerson from "./HobbiesPerson";
import "./HobbiesPeopleList.css";

function HobbiesPeopleList({ people, language }) {
  return (
    <Col className="hobbies-person-list">
      {people.map((element) => (
        <HobbiesPerson
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
        />
      ))}
    </Col>
  );
}

export default HobbiesPeopleList;
